import { Button, Result } from 'antd';
import styled from 'styled-components';
import useT from '@tools/ui-hooks/useT';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const VpnMissing = () => {
  const { t } = useT();

  return (
    <Container>
      <Result
        status="warning"
        title={t('vpnNotConnected')}
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            {t('reload') as string}
          </Button>
        }
      />
    </Container>
  );
};
